import type { ModuleWithProviders } from '@angular/core';
import { NgModule, inject } from '@angular/core';

import { Analytics, AnalyticsConfig, AnalyticsConfigOptions } from '@core/analytics-types';

import { AnalyticsGlobal } from './analytics-global';
import { AnalyticsRouteTracker } from './analytics-route.tracker';

@NgModule({
  imports: [],
  providers: [],
  exports: [],
})
export class RtAnalyticsModule {
  public static forRoot(opts: AnalyticsConfigOptions): ModuleWithProviders<RtAnalyticsModule> {
    return {
      ngModule: RtAnalyticsModule,
      providers: [
        {
          provide: Analytics,
          useClass: AnalyticsGlobal,
        },
        {
          provide: AnalyticsConfig,
          useValue: new AnalyticsConfig(opts),
        },
        ...(opts.trackRouteChange
          ? [
              {
                provide: AnalyticsRouteTracker,
              },
            ]
          : []),
      ],
    };
  }

  private readonly routeTracker = inject(AnalyticsRouteTracker, { optional: true });
}
